import { render, staticRenderFns } from "./ArchiveBulkActionRow.vue?vue&type=template&id=6d30e731&scoped=true&"
import script from "./ArchiveBulkActionRow.vue?vue&type=script&lang=js&"
export * from "./ArchiveBulkActionRow.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveBulkActionRow.vue?vue&type=style&index=0&id=6d30e731&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d30e731",
  null
  
)

export default component.exports